<template>
  <div>
    <navbar :is-spaced="false" />
    <nuxt-child :site-name="name" />
    <section v-if="$route.path === '/'" class="section is-small">
      <div class="container">
        <loan-application />
      </div>
    </section>
    <lazy-hydrate ssr-only>
      <footer-comp logo="false" />
    </lazy-hydrate>
  </div>
</template>

<script>
import LazyHydrate from 'vue-lazy-hydration'

export default {
  layout: 'whitelabel',
  components: {
    LazyHydrate,
    footerComp: () => import( '~/whitelabels/components/footer' ),
    loanApplication: () => import( '~/components/loanApplication' ),
    navbar: () => import( '~/whitelabels/components/navbar' )
  },
  head () {
    const desc = 'Rahatalo löytää puolestasi markkinoiden parhaimman lainan tai pikavipin. Yhdellä hakemuksella jopa yli 20 lainatarjousta. Hae lainaa 500 – 50000 € ja saat lainapäätöksen heti. Auki 24/7.'
    const theme = '#e4c11f'
    return {
      title: `${this.name} | Lainahakemus`,
      meta: [
        { hid: 'description', name: 'description', content: desc },
        { hid: 'og:title', name: 'og:title', property: 'og:title', content: this.name },
        { hid: 'og:site_name', name: 'og:site_name', property: 'og:site_name', content: this.name },
        { hid: 'og:description', name: 'og:description', property: 'og:description', content: desc },
        { hid: 'apple-mobile-web-app-title', name: 'apple-mobile-web-app-title', content: this.name },
        { hid: 'theme-color', name: 'theme-color', content: theme }
      ],
      link: [{ rel: 'icon', type: 'image/x-icon', href: require( '~/assets/whitelabels/rahatalo/favicon.png' ) }]
    }
  },
  data () {
    return {
      name: 'Rahatalo',
      domain: 'rahatalo.fi'
    }
  }
}
</script>

<style lang="scss">
@import "~assets/whitelabels/scss/_variables.scss";

$wl-primary: #e4c11f;
$wl-body-background: linear-gradient(to bottom, #f3f3f5 1%, #fff 100%);

$wl-navbar-background: #fff;
$wl-navbar-height: 7.5rem;
$wl-navbar-logo-height: 4.75rem;

$wl-slider-handle-border: 2px solid white;

$wl-footer-color: white;
$wl-footer-background: linear-gradient(to bottom, #2e3979 0%, #18204b 100%);

@import "~assets/whitelabels/scss/styles.scss";

.whitelabel.rahatalo {
  @include whitelabel;
}
</style>
